import { ResourceProps } from "react-admin";
import Icon from "@mui/icons-material/NightShelter";
import { Resource } from "../../enums";
import ListScreen from "./list";
import { EditScreen } from "./edit";

const contactUsPages: ResourceProps = {
  name: Resource.CONTACT_US_PAGES,
  icon: Icon,
  list: ListScreen,
  edit: EditScreen,
  options: {
    label: "Contact Us",
  },
};

export default contactUsPages;
